import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={18}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.965 6.609a.685.685 0 0 1 .697.02l4.678 2.963a.685.685 0 0 1 .002 1.155l-4.669 2.976a.685.685 0 0 1-1.052-.576l-.01-5.938c0-.25.136-.48.354-.6Zm1.017 1.844.006 3.446 2.71-1.727-2.716-1.719ZM2.715.616a.685.685 0 0 1 .887-.39l2.866 1.119a.685.685 0 0 1 .389.887L5.738 5.093a.685.685 0 0 1-1.275-.498l.869-2.224-2.228-.869a.685.685 0 0 1-.389-.886Z"
      fill="#00000099"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.855 1.758a.685.685 0 0 1-.416.874 7.631 7.631 0 1 0 9.956 5.31 7.631 7.631 0 0 0-4.436-5.154.685.685 0 0 1 .532-1.262A9 9 0 1 1 1.67 15.043 9 9 0 0 1 .415 7.12m6.44-5.362a.685.685 0 0 0-.875-.415l.875.415Zm-.875-.415A9 9 0 0 0 .415 7.12L5.98 1.343Z"
      fill="#00000099"
    />
  </svg>
)

export default SvgComponent